import { InjectionToken } from '@angular/core';
import { Observable } from 'rxjs';

import { ReadjustmentRequestDto } from '@app/data/dtos/ptrab/irpf-readjustment/readjustment-request.dto';
import { TwoFactorAuthorization } from '@app/entities/interfaces/ptrab/two-factor-authorization.interface';
import { Readjustment } from '@app/entities/models/ptrab/irpf-readjustment/readjustment.model';
import { MSafeAny } from '@app/shared/models/safe-any/safe-any.model';

export interface IrpfReadjustmentRepository {
  getReadjustment(): Observable<Readjustment>;
  setRegularization(params: ReadjustmentRequestDto, authorization: TwoFactorAuthorization): Observable<MSafeAny>;
}
export const IRPF_READJUSTMENT_REPOSITORY = new InjectionToken<IrpfReadjustmentRepository>(
  'IRPF_READJUSTMENT_REPOSITORY'
);
